import { render, staticRenderFns } from "./htgl.vue?vue&type=template&id=16218fe4&scoped=true&"
import script from "./htgl.vue?vue&type=script&lang=js&"
export * from "./htgl.vue?vue&type=script&lang=js&"
import style0 from "./htgl.vue?vue&type=style&index=0&id=16218fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16218fe4",
  null
  
)

export default component.exports